const data =  [
  {
    id: 1,
    title: "boAt BassHeads 100 in-Ear Wired Headphones with Mic (Black)",
    img: "https://m.media-amazon.com/images/I/719elVA3FvL._AC_UY218_.jpg",
    desc:"The perfect way to add some style and stand out from the crowd with the boAt BassHeads 100 Hawk inspired earphones.",
    category:"earphones",
    brand:"boat",
    price: 370,
    quantity: 1,
  },
  {
    id: 2,
    title: "Sony Premium MDR-XB55AP in-Ear Extra Bass Wired Headphones",
    img: "https://m.media-amazon.com/images/I/51x1sdb9K6L._AC_UY218_.jpg",
    desc:"Listen to your favorite music like it deserves. 12 MM neodymium creates powerful, balanced sound in detail.",
    category:"earphones",
    brand:"sony",
    price: 1999,
    quantity: 1,
  },
  {
    id: 3,
    title: "JBL C50HI, Wired in Ear Headphones with Mic",
    img: "https://m.media-amazon.com/images/I/61bKM6CSSFL._AC_UY218_.jpg",
    desc:"Experience deepened notes with true JBL level bass response making everyday musical journey more appealing.",
    category:"earphones",
    brand:"jbl",
    price: 499,
    quantity: 1,
  },
  {
    id: 4,
    title: "JBL T460BT by Harman, Wireless On Ear Headphones with Mic",
    img: "https://m.media-amazon.com/images/I/71ynIMjwgwL._AC_UY218_.jpg",
    desc:"Superior listening experience with JBL Pure Bass sound with Wireless Bluetooth Streaming",
    category:"headphones",
    brand:"jbl",
    price: 2699,
    quantity: 1,
  },
  {
    id: 5,
    title: "Sony Wh-Ch510 Bluetooth Wireless On Ear Headphones",
    img: "https://m.media-amazon.com/images/I/51i+LdztEBL._AC_UY218_.jpg",
    desc:"Listen to your favourite tracks wirelessly with a Bluetooth wireless technology by pairing your smartphone or tablet.",
    category:"headphones",
    brand:"sony",
    price: 2499,
    quantity: 1,
  },
  {
    id: 6,
    title: "Sennheiser HD 458 ANC Foldable Bluetooth Wireless Over Ear Headphones",
    img: "https://m.media-amazon.com/images/I/71zPb+U1ybL._AC_UY218_.jpg",
    desc:"The new look comes with active noise cancellation and high-quality wireless codec support to provide distraction-less and captivating sound quality.",
    category:"headphones",
    brand:"sennheiser",
    price: 8990,
    quantity: 1,
  },
  {
    id: 7,
    title: "boAt Stone 135 Portable Wireless Speaker with 5W RMS Immersive Sound",
    img: "https://m.media-amazon.com/images/I/61BZ1cEl6oL._AC_UY218_.jpg",
    desc:"Get ready to be enthralled by the 5W RMS sound on Stone 135 portable wireless speakers.",
    category:"speakers",
    brand:"boat",
    price: 899,
    quantity: 1,
  },
  {
    id: 8,
    title: "JBL Flip 4, Wireless Portable Bluetooth Speaker with Mic",
    img: "https://m.media-amazon.com/images/I/61bwTIJQWXL._AC_UY218_.jpg",
    desc:"Hear the bass, feel the bass, see the bass. Dual external passive radiators demonstrate just how powerful your speaker is.",
    category:"speakers",
    brand:"jbl",
    price: 7999,
    quantity: 1,
  },
  {
    id: 9,
    title: "Tribit XSound Go 16W 5.0 Bluetooth Speaker with Loud Sound & Rich Bass",
    img: "https://m.media-amazon.com/images/I/71BJbii7jlL._AC_UY218_.jpg",
    desc:"With crystal highs, crisp mids and rich bass, Tribit XSound Go Speaker creates an surprisingly immersive listening experience unlike any other.",
    category:"speakers",
    brand:"tribit",
    price: 2799,
    quantity: 1,
  },
  {
    id: 10,
    title: "Bose SoundLink Flex Bluetooth Portable Speaker",
    img: "https://m.media-amazon.com/images/I/71we5E107KL._AC_UY218_.jpg",
    desc:"The SoundLink Flex portable speaker does more than just immerse you – it provides a deep connection to your music.",
    category:"speakers",
    brand:"bose",
    price: 15900,
    quantity: 1,
  },
  {
    id: 11,
    title: "Bose Soundsport Sweatproof Bluetooth Wireless In Ear Earphones With Mic",
    img: "https://m.media-amazon.com/images/I/61j6ZKGcXrL._AC_UY218_.jpg",
    desc:"Go ahead, push yourself there are no wires holding you back, and you have impressive audio performance to match your intensity.",
    category:"earphones",
    brand:"bose",
    price: 9999,
    quantity: 1,
  },
  {
    id: 12,
    title: "Bose Quietcomfort 45 Bluetooth Wireless Over Ear Headphones with Mic Noise Cancelling",
    img: "https://m.media-amazon.com/images/I/51JbsHSktkL._AC_UY218_.jpg",
    desc:"The first noise-canceling headphones are back, now with the new Aware Mode, lightweight materials for comfort.",
    category:"headphones",
    brand:"bose",
    price: 29900,
    quantity: 1,
  },
  {
    id: 13,
    title: "Audio-Technica Ath-M20X Wired Over Ear Headphones Without Mic",
    img: "https://m.media-amazon.com/images/I/71HlB-gf46L._AC_UY218_.jpg",
    desc:"Online reviewers and top audio professionals have long agreed that the ATH-M50 is an unmatched combination of audio and build quality.",
    category:"headphones",
    brand:"audio-technica",
    price: 4499,
    quantity: 1,
  },
  {
    id: 14,
    title: "Beats Studio3 Wireless Bluetooth On Ear Headphone with Mic",
    img: "https://m.media-amazon.com/images/I/618aVzbPMjL._AC_UY218_.jpg",
    desc:"High-performance wireless noise cancelling headphones with pure adaptive noise canceling (pure ANC) actively blocks external noise.",
    category:"headphones",
    brand:"beats",
    price: 25900,
    quantity: 1,
  },
  {
    id: 15,
    title: "beyerdynamic DT 770 Pro 80 Wired Over Ear Headphone Without Mic",
    img: "https://m.media-amazon.com/images/I/61F0AVOoZvL._AC_UY218_.jpg",
    desc:"Closed over-ear headphones for professional sound in the studio and on mobile devices such as tablets and smartphones.",
    category:"headphones",
    brand:"beyerdynamic",
    price: 13848,
    quantity: 1,
  },
  {
    id: 16,
    title: "JBL Tune 215BT in Ear Bluetooth Wireless Earphones with Mic",
    img: "https://m.media-amazon.com/images/I/61WjkBfSzyL._AC_UY218_.jpg",
    desc:"Enjoy balanced sound without artificially enhanced Bass and volume that hurts your ears.",
    category:"earphones",
    brand:"jbl",
    price: 1499,
    quantity: 1,
  },
  {
    id: 17,
    title: "Sony WI-XB400 Wireless Extra Bass in-Ear earphones",
    img: "https://m.media-amazon.com/images/I/71+GXwLe23L._AC_UY218_.jpg",
    desc:"EXTRA BASS enhances all your low-end frequencies, lifting every track with wave after wave of thundering rhythm.",
    category:"earphones",
    brand:"sony",
    price: 3238,
    quantity: 1,
  },
  {
    id: 18,
    title: "Sony SRS-XE200 X-Series Wireless Ultra Portable Bluetooth Speaker",
    img: "https://m.media-amazon.com/images/I/71TQz9ITcUL._AC_UY218_.jpg",
    desc:"Line shaped diffuser distributes music evenly across a wide sound stage with Balanced speakers for powerful bass and crisp sound.",
    category:"speakers",
    brand:"sony",
    price: 9990,
    quantity: 1,
  },

]

export default data;